export const environment = {
  baseUrl: 'https://quiz.eu.aodocs.app',
  apiUrl: '/_ah/api/',
  aodocsUrl: 'https://eu.aodocs.app/',
  clientId: '585891590092-98qkn7ajh7pu3t3o414knjmooof4illa.apps.googleusercontent.com',
  version: '1.0.0',
  production: true,
};
